import { render } from "./convert.vue?vue&type=template&id=081966d0&scoped=true"
import script from "./convert.vue?vue&type=script&lang=js"
export * from "./convert.vue?vue&type=script&lang=js"

import "./convert.vue?vue&type=style&index=0&id=081966d0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081966d0"]])

export default __exports__